<div
    class="menu-button"
    [ngClass]="{'close-button': menuService.isMenuOpened | async}"
>
    <div class="line top"></div>
    <div class="line middle"></div>
    <div class="line bottom"></div>
</div>
